export default function() {
  return !this.node();
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/selection/empty.js
// module id = 2202
// module chunks = 2